import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { useProduct, useUpdateURL } from '../product/product-context';
import Image from '../Image';

export function Gallery({ images }: { images: { src: string; altText: string }[] }) {
  const { state, updateImage } = useProduct();
  const updateURL = useUpdateURL();
  const imageIndex = state.image ? parseInt(state.image) : 0;

  const nextImageIndex = imageIndex + 1 < images.length ? imageIndex + 1 : 0;
  const previousImageIndex = imageIndex === 0 ? images.length - 1 : imageIndex - 1;

  const buttonClassName =
    'h-full px-6 transition-all ease-in-out hover:scale-110 hover:text-neutral-900 flex items-center justify-center text-neutral-500';

  return (
    <>
      <div className="relative aspect-[4/5] h-full max-h-[680px] w-full overflow-hidden rounded-2xl">
        {images[imageIndex] && (
          <Image
            className="h-full w-full object-contain rounded-2xl"
            fill
            sizes="(min-width: 1024px) 66vw, 100vw"
            alt={images[imageIndex]?.altText as string}
            src={images[imageIndex]?.src as string}
            priority={true}
          />
        )}

        {images.length > 1 ? (
          <div className="absolute bottom-[15%] flex w-full justify-center">
            <div className="mx-auto flex h-11 items-center rounded-full border border-neutral-200 bg-white/90 text-neutral-500 backdrop-blur-sm shadow-sm">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  const newState = updateImage(previousImageIndex.toString());
                  updateURL(newState);
                }}
                aria-label="Previous product image"
                className={buttonClassName}
              >
                <ArrowLeftIcon className="h-5" />
              </button>
              <div className="mx-1 h-6 w-px bg-neutral-500"></div>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  const newState = updateImage(nextImageIndex.toString());
                  updateURL(newState);
                }}
                aria-label="Next product image"
                className={buttonClassName}
              >
                <ArrowRightIcon className="h-5" />
              </button>
            </div>
          </div>
        ) : null}
      </div>

      {images.length > 1 ? (
        <ul className="my-12 flex items-center flex-wrap justify-center gap-2 overflow-x-auto overflow-y-hidden py-1 lg:mb-0 scrollbar-hide">
          {images.map((image, index) => {
            const isActive = index === imageIndex;

            return (
              <li key={image.src} className="h-20 w-20 flex-shrink-0">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    const newState = updateImage(index.toString());
                    updateURL(newState);
                  }}
                  aria-label="Select product image"
                  className={`h-full w-full overflow-hidden rounded-2xl border-2 transition-colors ${isActive ? 'border-rose-500' : 'border-neutral-200'}`}
                >
                  <Image
                    alt={image.altText}
                    src={image.src}
                    width={80}
                    height={80}
                    className="h-full w-full object-cover"
                  />
                </button>
              </li>
            );
          })}
        </ul>
      ) : null}
    </>
  );
}



